export default __webpack_public_path__ + "c4734d59d01066302d414b9fae2894e4.png";